import React, {createContext, useState, useContext, ReactNode, useEffect} from 'react';
import {MatchHighlightParams} from "@/types/contentTypes";


// 1. Definiamo la struttura dei dati che il Context metterà a disposizione
interface ContentSpecificContextType {
    contentSpecificParams: MatchHighlightParams | undefined;
    setContentSpecificParams: React.Dispatch<React.SetStateAction<MatchHighlightParams | undefined>>;
}


const ContentSpecificContext = createContext<ContentSpecificContextType | undefined>(undefined);


interface ContentSpecificProviderProps {
    children: ReactNode;
}

export const ContentSpecificProvider: React.FC<ContentSpecificProviderProps> = ({ children }) => {
    const [contentSpecificParams, setContentSpecificParams] = useState<MatchHighlightParams | undefined>();

    return (
        <ContentSpecificContext.Provider value={{ contentSpecificParams, setContentSpecificParams }}>
            {children}
        </ContentSpecificContext.Provider>
    );
};

// 4. Creiamo un Custom Hook per consumare il context in modo sicuro
export const useContentSpecificParams = (): ContentSpecificContextType => {
    const context = useContext(ContentSpecificContext);

    // Controllo di sicurezza: se il context è undefined, significa che
    // stiamo usando l'hook fuori dal Provider
    if (context === undefined) {
        throw new Error('useContentSpecificParams deve essere utilizzato all\'interno di un ContentSpecificProvider');
    }

    return context;
};